module.exports = __webpack_public_path__ + "static/media/integral_card_1.4cc3f22d.png";